<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 class="mb-4 mt-2">
        <v-card
          class="
            error_card
            mx-2 mx-lg-3
            py-10
            px-5
            d-flex
            flex-column
            align-center
            elevation-0
          "
          color="#F9DBDB"
        >
          <div
            class="card_title mb-1"
            :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '64px' : '36px' }"
          >
            {{ item.title }}
          </div>
          <div class="card_text mb-6">{{ item.text }}</div>
          <div class="card_image text-center">
            <img src="../assets/error.svg" alt="image" />
          </div>
          <v-btn
            class="card_btn mt-14 mt-md-9"
            width="256px"
            height="60px"
            outlined
            rounded
            color="#743D3D"
            @click="goToDashboard"
          >
            Go to my dashboard
          </v-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Error",
  data() {
    return {
      item: {
        title: "Error",
        text: "Blablabla",
      },
    };
  },
  created() {
    this.$root.breadcrumbs = [
      {
        text: "Home",
        href: "/",
      },
      {
        text: "Shop",
        href: "/shop",
        icon: "../assets/arrow.svg",
      },
    ];
  },
  methods: {
    goToDashboard() {
      this.$router.push({ path: "/dashboard" });
    },
  },
};
</script>
<style scoped>
.error_card {
  border-radius: 20px !important;
}
.card_title {
  color: #743d3d;
}
.card_text {
  color: #172745;
  font-size: 18px;
}
.card_image {
  width: 100%;
}
.card_image img {
  max-width: 80%;
}
.card_btn {
  text-transform: none;
  font-size: 18px !important;
  font-weight: normal;
}
</style>
